import React, { useState, useRef } from 'react';

interface SliderProps {
  title: string;
  value: number;
  onChange: (newValue: number) => void;
}

const CustomSlider: React.FC<SliderProps> = ({ title, value, onChange }) => {
  const sliderRef = useRef<HTMLDivElement>(null);
  const [tempValue, setTempValue] = useState(value);

  const minValue = -35;
  const maxValue = 35;

  // 현재 마우스 위치에 따라 값 계산하는 함수
  const calculateNewValue = (clientX: number) => {
    if (!sliderRef.current) return value;

    const rect = sliderRef.current.getBoundingClientRect();
    let newPos = (clientX - rect.left) / rect.width;

    newPos = minValue + newPos * (maxValue - minValue);
    newPos = Math.round(Math.max(minValue, Math.min(maxValue, newPos)));

    return newPos;
  };

  const handleDrag = (e: MouseEvent | TouchEvent) => {
    const clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
    setTempValue(calculateNewValue(clientX)); // UI에 즉시 반영
  };

  const startDrag = (e: React.MouseEvent | React.TouchEvent) => {
    document.addEventListener('mousemove', handleDrag);
    document.addEventListener('mouseup', stopDrag);
    document.addEventListener('touchmove', handleDrag);
    document.addEventListener('touchend', stopDrag);
  };

  const stopDrag = (e: MouseEvent | TouchEvent) => {
    document.removeEventListener('mousemove', handleDrag);
    document.removeEventListener('mouseup', stopDrag);
    document.removeEventListener('touchmove', handleDrag);
    document.removeEventListener('touchend', stopDrag);

    let clientX;
    if ('touches' in e) {
      if (e.touches.length > 0) {
        clientX = e.touches[0].clientX;
      } else if (e.changedTouches && e.changedTouches.length > 0) {
        clientX = e.changedTouches[0].clientX;
      } else {
        onChange(tempValue);
        return;
      }
    } else {
      clientX = e.clientX;
    }

    const finalValue = calculateNewValue(clientX);
    setTempValue(finalValue);
    onChange(finalValue);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        backgroundColor: '#12131A',
        padding: '10px',
        borderRadius: '10px',
        overflowX: 'auto',
      }}
    >
      <strong style={{ width: '90px', color: 'white', fontSize: '16px' }}>
        {title}
      </strong>

      {/* 구분선 */}
      <div style={{ width: '2px', height: '24px', backgroundColor: '#555' }} />

      {/* 슬라이더 바 & 값 표시 */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        {/* 슬라이더 바 */}
        <div
          ref={sliderRef}
          style={{
            flex: 1,
            height: '6px',
            backgroundColor: '#DFFF64',
            position: 'relative',
            borderRadius: '3px',
            marginRight: '10px',
            cursor: 'pointer',
          }}
          onMouseDown={startDrag}
          onTouchStart={startDrag}
        >
          {/* 동그란 버튼 */}
          <div
            style={{
              display: 'block',
              padding: '10px',
              borderRadius: '50%',
              position: 'absolute',
              top: '50%',
              left: `${
                ((tempValue - minValue) / (maxValue - minValue)) * 100
              }%`,
              transform: 'translate(-50%, -50%)',
              cursor: 'grab',
              boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.2)',
            }}
          >
            <div
              style={{
                width: '16px',
                height: '16px',
                backgroundColor: 'white',
                borderRadius: '50%',
              }}
            />
          </div>
        </div>

        {/* 현재 값 표시 */}
        <span
          style={{
            width: '25px',
            fontSize: '14px',
            color: '#ccc',
            textAlign: 'center',
          }}
        >
          {tempValue}
        </span>
      </div>
    </div>
  );
};

export default CustomSlider;
